// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import { frontmatter as fm0, toc as t0 } from '/home/runner/work/GPT-Vis/GPT-Vis/docs/guide/custome-markdown.en.md?type=frontmatter';
import { demoIndex as dmi0 } from '/home/runner/work/GPT-Vis/GPT-Vis/docs/guide/custome-markdown.en.md?type=demo-index';
import { frontmatter as fm1, toc as t1 } from '/home/runner/work/GPT-Vis/GPT-Vis/docs/guide/customize-style.en.md?type=frontmatter';
import { demoIndex as dmi1 } from '/home/runner/work/GPT-Vis/GPT-Vis/docs/guide/customize-style.en.md?type=demo-index';
import { frontmatter as fm2, toc as t2 } from '/home/runner/work/GPT-Vis/GPT-Vis/docs/guide/antd-design-x.en.md?type=frontmatter';
import { demoIndex as dmi2 } from '/home/runner/work/GPT-Vis/GPT-Vis/docs/guide/antd-design-x.en.md?type=demo-index';
import { frontmatter as fm3, toc as t3 } from '/home/runner/work/GPT-Vis/GPT-Vis/docs/guide/custome-markdown.md?type=frontmatter';
import { demoIndex as dmi3 } from '/home/runner/work/GPT-Vis/GPT-Vis/docs/guide/custome-markdown.md?type=demo-index';
import { frontmatter as fm4, toc as t4 } from '/home/runner/work/GPT-Vis/GPT-Vis/docs/guide/customize-style.md?type=frontmatter';
import { demoIndex as dmi4 } from '/home/runner/work/GPT-Vis/GPT-Vis/docs/guide/customize-style.md?type=demo-index';
import { frontmatter as fm5, toc as t5 } from '/home/runner/work/GPT-Vis/GPT-Vis/docs/guide/quick-start.en.md?type=frontmatter';
import { demoIndex as dmi5 } from '/home/runner/work/GPT-Vis/GPT-Vis/docs/guide/quick-start.en.md?type=demo-index';
import { frontmatter as fm6, toc as t6 } from '/home/runner/work/GPT-Vis/GPT-Vis/docs/guide/antd-design-x.md?type=frontmatter';
import { demoIndex as dmi6 } from '/home/runner/work/GPT-Vis/GPT-Vis/docs/guide/antd-design-x.md?type=demo-index';
import { frontmatter as fm7, toc as t7 } from '/home/runner/work/GPT-Vis/GPT-Vis/docs/guide/custom-ui.en.md?type=frontmatter';
import { demoIndex as dmi7 } from '/home/runner/work/GPT-Vis/GPT-Vis/docs/guide/custom-ui.en.md?type=demo-index';
import { frontmatter as fm8, toc as t8 } from '/home/runner/work/GPT-Vis/GPT-Vis/docs/guide/quick-start.md?type=frontmatter';
import { demoIndex as dmi8 } from '/home/runner/work/GPT-Vis/GPT-Vis/docs/guide/quick-start.md?type=demo-index';
import { frontmatter as fm9, toc as t9 } from '/home/runner/work/GPT-Vis/GPT-Vis/docs/guide/custom-ui.md?type=frontmatter';
import { demoIndex as dmi9 } from '/home/runner/work/GPT-Vis/GPT-Vis/docs/guide/custom-ui.md?type=demo-index';
import { frontmatter as fm10, toc as t10 } from '/home/runner/work/GPT-Vis/GPT-Vis/docs/index.en.md?type=frontmatter';
import { demoIndex as dmi10 } from '/home/runner/work/GPT-Vis/GPT-Vis/docs/index.en.md?type=demo-index';
import { frontmatter as fm11, toc as t11 } from '/home/runner/work/GPT-Vis/GPT-Vis/docs/index.md?type=frontmatter';
import { demoIndex as dmi11 } from '/home/runner/work/GPT-Vis/GPT-Vis/docs/index.md?type=demo-index';
import { frontmatter as fm12, toc as t12 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Area/index.en.md?type=frontmatter';
import { demoIndex as dmi12 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Area/index.en.md?type=demo-index';
import { frontmatter as fm13, toc as t13 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Area/index.md?type=frontmatter';
import { demoIndex as dmi13 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Area/index.md?type=demo-index';
import { frontmatter as fm14, toc as t14 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Bar/index.en.md?type=frontmatter';
import { demoIndex as dmi14 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Bar/index.en.md?type=demo-index';
import { frontmatter as fm15, toc as t15 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Bar/index.md?type=frontmatter';
import { demoIndex as dmi15 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Bar/index.md?type=demo-index';
import { frontmatter as fm16, toc as t16 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Boxplot/index.en.md?type=frontmatter';
import { demoIndex as dmi16 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Boxplot/index.en.md?type=demo-index';
import { frontmatter as fm17, toc as t17 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Boxplot/index.md?type=frontmatter';
import { demoIndex as dmi17 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Boxplot/index.md?type=demo-index';
import { frontmatter as fm18, toc as t18 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/ChartCodeRender/index.en.md?type=frontmatter';
import { demoIndex as dmi18 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/ChartCodeRender/index.en.md?type=demo-index';
import { frontmatter as fm19, toc as t19 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/ChartCodeRender/index.md?type=frontmatter';
import { demoIndex as dmi19 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/ChartCodeRender/index.md?type=demo-index';
import { frontmatter as fm20, toc as t20 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Column/index.en.md?type=frontmatter';
import { demoIndex as dmi20 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Column/index.en.md?type=demo-index';
import { frontmatter as fm21, toc as t21 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Column/index.md?type=frontmatter';
import { demoIndex as dmi21 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Column/index.md?type=demo-index';
import { frontmatter as fm22, toc as t22 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/ConfigProvider/index.en.md?type=frontmatter';
import { demoIndex as dmi22 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/ConfigProvider/index.en.md?type=demo-index';
import { frontmatter as fm23, toc as t23 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/ConfigProvider/index.md?type=frontmatter';
import { demoIndex as dmi23 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/ConfigProvider/index.md?type=demo-index';
import { frontmatter as fm24, toc as t24 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/DualAxes/index.en.md?type=frontmatter';
import { demoIndex as dmi24 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/DualAxes/index.en.md?type=demo-index';
import { frontmatter as fm25, toc as t25 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/DualAxes/index.md?type=frontmatter';
import { demoIndex as dmi25 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/DualAxes/index.md?type=demo-index';
import { frontmatter as fm26, toc as t26 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/FishboneDiagram/index.en.md?type=frontmatter';
import { demoIndex as dmi26 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/FishboneDiagram/index.en.md?type=demo-index';
import { frontmatter as fm27, toc as t27 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/FishboneDiagram/index.md?type=frontmatter';
import { demoIndex as dmi27 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/FishboneDiagram/index.md?type=demo-index';
import { frontmatter as fm28, toc as t28 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/FlowDiagram/index.en.md?type=frontmatter';
import { demoIndex as dmi28 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/FlowDiagram/index.en.md?type=demo-index';
import { frontmatter as fm29, toc as t29 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/FlowDiagram/index.md?type=frontmatter';
import { demoIndex as dmi29 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/FlowDiagram/index.md?type=demo-index';
import { frontmatter as fm30, toc as t30 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Funnel/index.en.md?type=frontmatter';
import { demoIndex as dmi30 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Funnel/index.en.md?type=demo-index';
import { frontmatter as fm31, toc as t31 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Funnel/index.md?type=frontmatter';
import { demoIndex as dmi31 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Funnel/index.md?type=demo-index';
import { frontmatter as fm32, toc as t32 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/GPTVis/index.en.md?type=frontmatter';
import { demoIndex as dmi32 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/GPTVis/index.en.md?type=demo-index';
import { frontmatter as fm33, toc as t33 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/GPTVis/index.md?type=frontmatter';
import { demoIndex as dmi33 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/GPTVis/index.md?type=demo-index';
import { frontmatter as fm34, toc as t34 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/HeatMap/index.en.md?type=frontmatter';
import { demoIndex as dmi34 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/HeatMap/index.en.md?type=demo-index';
import { frontmatter as fm35, toc as t35 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/HeatMap/index.md?type=frontmatter';
import { demoIndex as dmi35 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/HeatMap/index.md?type=demo-index';
import { frontmatter as fm36, toc as t36 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Histogram/index.en.md?type=frontmatter';
import { demoIndex as dmi36 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Histogram/index.en.md?type=demo-index';
import { frontmatter as fm37, toc as t37 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Histogram/index.md?type=frontmatter';
import { demoIndex as dmi37 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Histogram/index.md?type=demo-index';
import { frontmatter as fm38, toc as t38 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/IndentedTree/index.en.md?type=frontmatter';
import { demoIndex as dmi38 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/IndentedTree/index.en.md?type=demo-index';
import { frontmatter as fm39, toc as t39 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/IndentedTree/index.md?type=frontmatter';
import { demoIndex as dmi39 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/IndentedTree/index.md?type=demo-index';
import { frontmatter as fm40, toc as t40 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Line/index.en.md?type=frontmatter';
import { demoIndex as dmi40 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Line/index.en.md?type=demo-index';
import { frontmatter as fm41, toc as t41 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Line/index.md?type=frontmatter';
import { demoIndex as dmi41 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Line/index.md?type=demo-index';
import { frontmatter as fm42, toc as t42 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Liquid/index.en.md?type=frontmatter';
import { demoIndex as dmi42 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Liquid/index.en.md?type=demo-index';
import { frontmatter as fm43, toc as t43 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Liquid/index.md?type=frontmatter';
import { demoIndex as dmi43 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Liquid/index.md?type=demo-index';
import { frontmatter as fm44, toc as t44 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Map/index.en.md?type=frontmatter';
import { demoIndex as dmi44 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Map/index.en.md?type=demo-index';
import { frontmatter as fm45, toc as t45 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Map/index.md?type=frontmatter';
import { demoIndex as dmi45 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Map/index.md?type=demo-index';
import { frontmatter as fm46, toc as t46 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/MindMap/index.en.md?type=frontmatter';
import { demoIndex as dmi46 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/MindMap/index.en.md?type=demo-index';
import { frontmatter as fm47, toc as t47 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/MindMap/index.md?type=frontmatter';
import { demoIndex as dmi47 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/MindMap/index.md?type=demo-index';
import { frontmatter as fm48, toc as t48 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/NetworkGraph/index.en.md?type=frontmatter';
import { demoIndex as dmi48 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/NetworkGraph/index.en.md?type=demo-index';
import { frontmatter as fm49, toc as t49 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/NetworkGraph/index.md?type=frontmatter';
import { demoIndex as dmi49 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/NetworkGraph/index.md?type=demo-index';
import { frontmatter as fm50, toc as t50 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/OrganizationChart/index.en.md?type=frontmatter';
import { demoIndex as dmi50 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/OrganizationChart/index.en.md?type=demo-index';
import { frontmatter as fm51, toc as t51 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/OrganizationChart/index.md?type=frontmatter';
import { demoIndex as dmi51 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/OrganizationChart/index.md?type=demo-index';
import { frontmatter as fm52, toc as t52 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/PathMap/index.en.md?type=frontmatter';
import { demoIndex as dmi52 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/PathMap/index.en.md?type=demo-index';
import { frontmatter as fm53, toc as t53 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/PathMap/index.md?type=frontmatter';
import { demoIndex as dmi53 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/PathMap/index.md?type=demo-index';
import { frontmatter as fm54, toc as t54 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Pie/index.en.md?type=frontmatter';
import { demoIndex as dmi54 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Pie/index.en.md?type=demo-index';
import { frontmatter as fm55, toc as t55 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Pie/index.md?type=frontmatter';
import { demoIndex as dmi55 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Pie/index.md?type=demo-index';
import { frontmatter as fm56, toc as t56 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/PinMap/index.en.md?type=frontmatter';
import { demoIndex as dmi56 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/PinMap/index.en.md?type=demo-index';
import { frontmatter as fm57, toc as t57 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/PinMap/index.md?type=frontmatter';
import { demoIndex as dmi57 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/PinMap/index.md?type=demo-index';
import { frontmatter as fm58, toc as t58 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Radar/index.en.md?type=frontmatter';
import { demoIndex as dmi58 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Radar/index.en.md?type=demo-index';
import { frontmatter as fm59, toc as t59 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Radar/index.md?type=frontmatter';
import { demoIndex as dmi59 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Radar/index.md?type=demo-index';
import { frontmatter as fm60, toc as t60 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Render/index.en.md?type=frontmatter';
import { demoIndex as dmi60 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Render/index.en.md?type=demo-index';
import { frontmatter as fm61, toc as t61 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Render/index.md?type=frontmatter';
import { demoIndex as dmi61 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Render/index.md?type=demo-index';
import { frontmatter as fm62, toc as t62 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Sankey/index.en.md?type=frontmatter';
import { demoIndex as dmi62 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Sankey/index.en.md?type=demo-index';
import { frontmatter as fm63, toc as t63 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Sankey/index.md?type=frontmatter';
import { demoIndex as dmi63 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Sankey/index.md?type=demo-index';
import { frontmatter as fm64, toc as t64 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Scatter/index.en.md?type=frontmatter';
import { demoIndex as dmi64 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Scatter/index.en.md?type=demo-index';
import { frontmatter as fm65, toc as t65 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Scatter/index.md?type=frontmatter';
import { demoIndex as dmi65 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Scatter/index.md?type=demo-index';
import { frontmatter as fm66, toc as t66 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Spreadsheet/index.en.md?type=frontmatter';
import { demoIndex as dmi66 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Spreadsheet/index.en.md?type=demo-index';
import { frontmatter as fm67, toc as t67 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Spreadsheet/index.md?type=frontmatter';
import { demoIndex as dmi67 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Spreadsheet/index.md?type=demo-index';
import { frontmatter as fm68, toc as t68 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Table/index.en.md?type=frontmatter';
import { demoIndex as dmi68 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Table/index.en.md?type=demo-index';
import { frontmatter as fm69, toc as t69 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Table/index.md?type=frontmatter';
import { demoIndex as dmi69 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Table/index.md?type=demo-index';
import { frontmatter as fm70, toc as t70 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Text/index.en.md?type=frontmatter';
import { demoIndex as dmi70 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Text/index.en.md?type=demo-index';
import { frontmatter as fm71, toc as t71 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Text/index.md?type=frontmatter';
import { demoIndex as dmi71 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Text/index.md?type=demo-index';
import { frontmatter as fm72, toc as t72 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Treemap/index.en.md?type=frontmatter';
import { demoIndex as dmi72 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Treemap/index.en.md?type=demo-index';
import { frontmatter as fm73, toc as t73 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Treemap/index.md?type=frontmatter';
import { demoIndex as dmi73 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Treemap/index.md?type=demo-index';
import { frontmatter as fm74, toc as t74 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Venn/index.en.md?type=frontmatter';
import { demoIndex as dmi74 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Venn/index.en.md?type=demo-index';
import { frontmatter as fm75, toc as t75 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Venn/index.md?type=frontmatter';
import { demoIndex as dmi75 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Venn/index.md?type=demo-index';
import { frontmatter as fm76, toc as t76 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Violin/index.en.md?type=frontmatter';
import { demoIndex as dmi76 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Violin/index.en.md?type=demo-index';
import { frontmatter as fm77, toc as t77 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Violin/index.md?type=frontmatter';
import { demoIndex as dmi77 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Violin/index.md?type=demo-index';
import { frontmatter as fm78, toc as t78 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Waterfall/index.en.md?type=frontmatter';
import { demoIndex as dmi78 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Waterfall/index.en.md?type=demo-index';
import { frontmatter as fm79, toc as t79 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Waterfall/index.md?type=frontmatter';
import { demoIndex as dmi79 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/Waterfall/index.md?type=demo-index';
import { frontmatter as fm80, toc as t80 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/WordCloud/index.en.md?type=frontmatter';
import { demoIndex as dmi80 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/WordCloud/index.en.md?type=demo-index';
import { frontmatter as fm81, toc as t81 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/WordCloud/index.md?type=frontmatter';
import { demoIndex as dmi81 } from '/home/runner/work/GPT-Vis/GPT-Vis/src/WordCloud/index.md?type=demo-index';

export const filesMeta = {
  'docs/guide/custome-markdown.en': {
    frontmatter: fm0,
    toc: t0,
    demoIndex: dmi0,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/home/runner/work/GPT-Vis/GPT-Vis/docs/guide/custome-markdown.en.md?type=text'),
  },
  'docs/guide/customize-style.en': {
    frontmatter: fm1,
    toc: t1,
    demoIndex: dmi1,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/home/runner/work/GPT-Vis/GPT-Vis/docs/guide/customize-style.en.md?type=text'),
  },
  'docs/guide/antd-design-x.en': {
    frontmatter: fm2,
    toc: t2,
    demoIndex: dmi2,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/home/runner/work/GPT-Vis/GPT-Vis/docs/guide/antd-design-x.en.md?type=text'),
  },
  'docs/guide/custome-markdown': {
    frontmatter: fm3,
    toc: t3,
    demoIndex: dmi3,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/home/runner/work/GPT-Vis/GPT-Vis/docs/guide/custome-markdown.md?type=text'),
  },
  'docs/guide/customize-style': {
    frontmatter: fm4,
    toc: t4,
    demoIndex: dmi4,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/home/runner/work/GPT-Vis/GPT-Vis/docs/guide/customize-style.md?type=text'),
  },
  'docs/guide/quick-start.en': {
    frontmatter: fm5,
    toc: t5,
    demoIndex: dmi5,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/home/runner/work/GPT-Vis/GPT-Vis/docs/guide/quick-start.en.md?type=text'),
  },
  'docs/guide/antd-design-x': {
    frontmatter: fm6,
    toc: t6,
    demoIndex: dmi6,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/home/runner/work/GPT-Vis/GPT-Vis/docs/guide/antd-design-x.md?type=text'),
  },
  'docs/guide/custom-ui.en': {
    frontmatter: fm7,
    toc: t7,
    demoIndex: dmi7,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/home/runner/work/GPT-Vis/GPT-Vis/docs/guide/custom-ui.en.md?type=text'),
  },
  'docs/guide/quick-start': {
    frontmatter: fm8,
    toc: t8,
    demoIndex: dmi8,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/home/runner/work/GPT-Vis/GPT-Vis/docs/guide/quick-start.md?type=text'),
  },
  'docs/guide/custom-ui': {
    frontmatter: fm9,
    toc: t9,
    demoIndex: dmi9,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/home/runner/work/GPT-Vis/GPT-Vis/docs/guide/custom-ui.md?type=text'),
  },
  'docs/index.en': {
    frontmatter: fm10,
    toc: t10,
    demoIndex: dmi10,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/home/runner/work/GPT-Vis/GPT-Vis/docs/index.en.md?type=text'),
  },
  'docs/index': {
    frontmatter: fm11,
    toc: t11,
    demoIndex: dmi11,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/home/runner/work/GPT-Vis/GPT-Vis/docs/index.md?type=text'),
  },
  'components/Area/index.en': {
    frontmatter: fm12,
    toc: t12,
    demoIndex: dmi12,
    textGetter: () => import(/* webpackChunkName: "meta__Area__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Area/index.en.md?type=text'),
  },
  'components/Area/index': {
    frontmatter: fm13,
    toc: t13,
    demoIndex: dmi13,
    textGetter: () => import(/* webpackChunkName: "meta__Area" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Area/index.md?type=text'),
  },
  'components/Bar/index.en': {
    frontmatter: fm14,
    toc: t14,
    demoIndex: dmi14,
    textGetter: () => import(/* webpackChunkName: "meta__Bar__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Bar/index.en.md?type=text'),
  },
  'components/Bar/index': {
    frontmatter: fm15,
    toc: t15,
    demoIndex: dmi15,
    textGetter: () => import(/* webpackChunkName: "meta__Bar" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Bar/index.md?type=text'),
  },
  'components/Boxplot/index.en': {
    frontmatter: fm16,
    toc: t16,
    demoIndex: dmi16,
    textGetter: () => import(/* webpackChunkName: "meta__Boxplot__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Boxplot/index.en.md?type=text'),
  },
  'components/Boxplot/index': {
    frontmatter: fm17,
    toc: t17,
    demoIndex: dmi17,
    textGetter: () => import(/* webpackChunkName: "meta__Boxplot" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Boxplot/index.md?type=text'),
  },
  'components/ChartCodeRender/index.en': {
    frontmatter: fm18,
    toc: t18,
    demoIndex: dmi18,
    textGetter: () => import(/* webpackChunkName: "meta__ChartCodeRender__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/ChartCodeRender/index.en.md?type=text'),
  },
  'components/ChartCodeRender/index': {
    frontmatter: fm19,
    toc: t19,
    demoIndex: dmi19,
    textGetter: () => import(/* webpackChunkName: "meta__ChartCodeRender__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/ChartCodeRender/index.md?type=text'),
  },
  'components/Column/index.en': {
    frontmatter: fm20,
    toc: t20,
    demoIndex: dmi20,
    textGetter: () => import(/* webpackChunkName: "meta__Column__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Column/index.en.md?type=text'),
  },
  'components/Column/index': {
    frontmatter: fm21,
    toc: t21,
    demoIndex: dmi21,
    textGetter: () => import(/* webpackChunkName: "meta__Column" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Column/index.md?type=text'),
  },
  'components/ConfigProvider/index.en': {
    frontmatter: fm22,
    toc: t22,
    demoIndex: dmi22,
    textGetter: () => import(/* webpackChunkName: "meta__ConfigProvider__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/ConfigProvider/index.en.md?type=text'),
  },
  'components/ConfigProvider/index': {
    frontmatter: fm23,
    toc: t23,
    demoIndex: dmi23,
    textGetter: () => import(/* webpackChunkName: "meta__ConfigProvider" */'/home/runner/work/GPT-Vis/GPT-Vis/src/ConfigProvider/index.md?type=text'),
  },
  'components/DualAxes/index.en': {
    frontmatter: fm24,
    toc: t24,
    demoIndex: dmi24,
    textGetter: () => import(/* webpackChunkName: "meta__DualAxes__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/DualAxes/index.en.md?type=text'),
  },
  'components/DualAxes/index': {
    frontmatter: fm25,
    toc: t25,
    demoIndex: dmi25,
    textGetter: () => import(/* webpackChunkName: "meta__DualAxes" */'/home/runner/work/GPT-Vis/GPT-Vis/src/DualAxes/index.md?type=text'),
  },
  'components/FishboneDiagram/index.en': {
    frontmatter: fm26,
    toc: t26,
    demoIndex: dmi26,
    textGetter: () => import(/* webpackChunkName: "meta__FishboneDiagram__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/FishboneDiagram/index.en.md?type=text'),
  },
  'components/FishboneDiagram/index': {
    frontmatter: fm27,
    toc: t27,
    demoIndex: dmi27,
    textGetter: () => import(/* webpackChunkName: "meta__FishboneDiagram" */'/home/runner/work/GPT-Vis/GPT-Vis/src/FishboneDiagram/index.md?type=text'),
  },
  'components/FlowDiagram/index.en': {
    frontmatter: fm28,
    toc: t28,
    demoIndex: dmi28,
    textGetter: () => import(/* webpackChunkName: "meta__FlowDiagram__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/FlowDiagram/index.en.md?type=text'),
  },
  'components/FlowDiagram/index': {
    frontmatter: fm29,
    toc: t29,
    demoIndex: dmi29,
    textGetter: () => import(/* webpackChunkName: "meta__FlowDiagram" */'/home/runner/work/GPT-Vis/GPT-Vis/src/FlowDiagram/index.md?type=text'),
  },
  'components/Funnel/index.en': {
    frontmatter: fm30,
    toc: t30,
    demoIndex: dmi30,
    textGetter: () => import(/* webpackChunkName: "meta__Funnel__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Funnel/index.en.md?type=text'),
  },
  'components/Funnel/index': {
    frontmatter: fm31,
    toc: t31,
    demoIndex: dmi31,
    textGetter: () => import(/* webpackChunkName: "meta__Funnel" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Funnel/index.md?type=text'),
  },
  'components/GPTVis/index.en': {
    frontmatter: fm32,
    toc: t32,
    demoIndex: dmi32,
    textGetter: () => import(/* webpackChunkName: "meta__GPTVis__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/GPTVis/index.en.md?type=text'),
  },
  'components/GPTVis/index': {
    frontmatter: fm33,
    toc: t33,
    demoIndex: dmi33,
    textGetter: () => import(/* webpackChunkName: "meta__GPTVis" */'/home/runner/work/GPT-Vis/GPT-Vis/src/GPTVis/index.md?type=text'),
  },
  'components/HeatMap/index.en': {
    frontmatter: fm34,
    toc: t34,
    demoIndex: dmi34,
    textGetter: () => import(/* webpackChunkName: "meta__HeatMap__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/HeatMap/index.en.md?type=text'),
  },
  'components/HeatMap/index': {
    frontmatter: fm35,
    toc: t35,
    demoIndex: dmi35,
    textGetter: () => import(/* webpackChunkName: "meta__HeatMap" */'/home/runner/work/GPT-Vis/GPT-Vis/src/HeatMap/index.md?type=text'),
  },
  'components/Histogram/index.en': {
    frontmatter: fm36,
    toc: t36,
    demoIndex: dmi36,
    textGetter: () => import(/* webpackChunkName: "meta__Histogram__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Histogram/index.en.md?type=text'),
  },
  'components/Histogram/index': {
    frontmatter: fm37,
    toc: t37,
    demoIndex: dmi37,
    textGetter: () => import(/* webpackChunkName: "meta__Histogram" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Histogram/index.md?type=text'),
  },
  'components/IndentedTree/index.en': {
    frontmatter: fm38,
    toc: t38,
    demoIndex: dmi38,
    textGetter: () => import(/* webpackChunkName: "meta__IndentedTree__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/IndentedTree/index.en.md?type=text'),
  },
  'components/IndentedTree/index': {
    frontmatter: fm39,
    toc: t39,
    demoIndex: dmi39,
    textGetter: () => import(/* webpackChunkName: "meta__IndentedTree__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/IndentedTree/index.md?type=text'),
  },
  'components/Line/index.en': {
    frontmatter: fm40,
    toc: t40,
    demoIndex: dmi40,
    textGetter: () => import(/* webpackChunkName: "meta__Line__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Line/index.en.md?type=text'),
  },
  'components/Line/index': {
    frontmatter: fm41,
    toc: t41,
    demoIndex: dmi41,
    textGetter: () => import(/* webpackChunkName: "meta__Line" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Line/index.md?type=text'),
  },
  'components/Liquid/index.en': {
    frontmatter: fm42,
    toc: t42,
    demoIndex: dmi42,
    textGetter: () => import(/* webpackChunkName: "meta__Liquid__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Liquid/index.en.md?type=text'),
  },
  'components/Liquid/index': {
    frontmatter: fm43,
    toc: t43,
    demoIndex: dmi43,
    textGetter: () => import(/* webpackChunkName: "meta__Liquid" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Liquid/index.md?type=text'),
  },
  'components/Map/index.en': {
    frontmatter: fm44,
    toc: t44,
    demoIndex: dmi44,
    textGetter: () => import(/* webpackChunkName: "meta__Map__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Map/index.en.md?type=text'),
  },
  'components/Map/index': {
    frontmatter: fm45,
    toc: t45,
    demoIndex: dmi45,
    textGetter: () => import(/* webpackChunkName: "meta__Map" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Map/index.md?type=text'),
  },
  'components/MindMap/index.en': {
    frontmatter: fm46,
    toc: t46,
    demoIndex: dmi46,
    textGetter: () => import(/* webpackChunkName: "meta__MindMap__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/MindMap/index.en.md?type=text'),
  },
  'components/MindMap/index': {
    frontmatter: fm47,
    toc: t47,
    demoIndex: dmi47,
    textGetter: () => import(/* webpackChunkName: "meta__MindMap" */'/home/runner/work/GPT-Vis/GPT-Vis/src/MindMap/index.md?type=text'),
  },
  'components/NetworkGraph/index.en': {
    frontmatter: fm48,
    toc: t48,
    demoIndex: dmi48,
    textGetter: () => import(/* webpackChunkName: "meta__NetworkGraph__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/NetworkGraph/index.en.md?type=text'),
  },
  'components/NetworkGraph/index': {
    frontmatter: fm49,
    toc: t49,
    demoIndex: dmi49,
    textGetter: () => import(/* webpackChunkName: "meta__NetworkGraph" */'/home/runner/work/GPT-Vis/GPT-Vis/src/NetworkGraph/index.md?type=text'),
  },
  'components/OrganizationChart/index.en': {
    frontmatter: fm50,
    toc: t50,
    demoIndex: dmi50,
    textGetter: () => import(/* webpackChunkName: "meta__OrganizationChart__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/OrganizationChart/index.en.md?type=text'),
  },
  'components/OrganizationChart/index': {
    frontmatter: fm51,
    toc: t51,
    demoIndex: dmi51,
    textGetter: () => import(/* webpackChunkName: "meta__OrganizationChart" */'/home/runner/work/GPT-Vis/GPT-Vis/src/OrganizationChart/index.md?type=text'),
  },
  'components/PathMap/index.en': {
    frontmatter: fm52,
    toc: t52,
    demoIndex: dmi52,
    textGetter: () => import(/* webpackChunkName: "meta__PathMap__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/PathMap/index.en.md?type=text'),
  },
  'components/PathMap/index': {
    frontmatter: fm53,
    toc: t53,
    demoIndex: dmi53,
    textGetter: () => import(/* webpackChunkName: "meta__PathMap" */'/home/runner/work/GPT-Vis/GPT-Vis/src/PathMap/index.md?type=text'),
  },
  'components/Pie/index.en': {
    frontmatter: fm54,
    toc: t54,
    demoIndex: dmi54,
    textGetter: () => import(/* webpackChunkName: "meta__Pie__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Pie/index.en.md?type=text'),
  },
  'components/Pie/index': {
    frontmatter: fm55,
    toc: t55,
    demoIndex: dmi55,
    textGetter: () => import(/* webpackChunkName: "meta__Pie" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Pie/index.md?type=text'),
  },
  'components/PinMap/index.en': {
    frontmatter: fm56,
    toc: t56,
    demoIndex: dmi56,
    textGetter: () => import(/* webpackChunkName: "meta__PinMap__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/PinMap/index.en.md?type=text'),
  },
  'components/PinMap/index': {
    frontmatter: fm57,
    toc: t57,
    demoIndex: dmi57,
    textGetter: () => import(/* webpackChunkName: "meta__PinMap" */'/home/runner/work/GPT-Vis/GPT-Vis/src/PinMap/index.md?type=text'),
  },
  'components/Radar/index.en': {
    frontmatter: fm58,
    toc: t58,
    demoIndex: dmi58,
    textGetter: () => import(/* webpackChunkName: "meta__Radar__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Radar/index.en.md?type=text'),
  },
  'components/Radar/index': {
    frontmatter: fm59,
    toc: t59,
    demoIndex: dmi59,
    textGetter: () => import(/* webpackChunkName: "meta__Radar" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Radar/index.md?type=text'),
  },
  'components/Render/index.en': {
    frontmatter: fm60,
    toc: t60,
    demoIndex: dmi60,
    textGetter: () => import(/* webpackChunkName: "meta__Render__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Render/index.en.md?type=text'),
  },
  'components/Render/index': {
    frontmatter: fm61,
    toc: t61,
    demoIndex: dmi61,
    textGetter: () => import(/* webpackChunkName: "meta__Render__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Render/index.md?type=text'),
  },
  'components/Sankey/index.en': {
    frontmatter: fm62,
    toc: t62,
    demoIndex: dmi62,
    textGetter: () => import(/* webpackChunkName: "meta__Sankey__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Sankey/index.en.md?type=text'),
  },
  'components/Sankey/index': {
    frontmatter: fm63,
    toc: t63,
    demoIndex: dmi63,
    textGetter: () => import(/* webpackChunkName: "meta__Sankey" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Sankey/index.md?type=text'),
  },
  'components/Scatter/index.en': {
    frontmatter: fm64,
    toc: t64,
    demoIndex: dmi64,
    textGetter: () => import(/* webpackChunkName: "meta__Scatter__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Scatter/index.en.md?type=text'),
  },
  'components/Scatter/index': {
    frontmatter: fm65,
    toc: t65,
    demoIndex: dmi65,
    textGetter: () => import(/* webpackChunkName: "meta__Scatter" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Scatter/index.md?type=text'),
  },
  'components/Spreadsheet/index.en': {
    frontmatter: fm66,
    toc: t66,
    demoIndex: dmi66,
    textGetter: () => import(/* webpackChunkName: "meta__Spreadsheet__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Spreadsheet/index.en.md?type=text'),
  },
  'components/Spreadsheet/index': {
    frontmatter: fm67,
    toc: t67,
    demoIndex: dmi67,
    textGetter: () => import(/* webpackChunkName: "meta__Spreadsheet" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Spreadsheet/index.md?type=text'),
  },
  'components/Table/index.en': {
    frontmatter: fm68,
    toc: t68,
    demoIndex: dmi68,
    textGetter: () => import(/* webpackChunkName: "meta__Table__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Table/index.en.md?type=text'),
  },
  'components/Table/index': {
    frontmatter: fm69,
    toc: t69,
    demoIndex: dmi69,
    textGetter: () => import(/* webpackChunkName: "meta__Table" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Table/index.md?type=text'),
  },
  'components/Text/index.en': {
    frontmatter: fm70,
    toc: t70,
    demoIndex: dmi70,
    textGetter: () => import(/* webpackChunkName: "meta__Text__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Text/index.en.md?type=text'),
  },
  'components/Text/index': {
    frontmatter: fm71,
    toc: t71,
    demoIndex: dmi71,
    textGetter: () => import(/* webpackChunkName: "meta__Text" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Text/index.md?type=text'),
  },
  'components/Treemap/index.en': {
    frontmatter: fm72,
    toc: t72,
    demoIndex: dmi72,
    textGetter: () => import(/* webpackChunkName: "meta__Treemap__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Treemap/index.en.md?type=text'),
  },
  'components/Treemap/index': {
    frontmatter: fm73,
    toc: t73,
    demoIndex: dmi73,
    textGetter: () => import(/* webpackChunkName: "meta__Treemap" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Treemap/index.md?type=text'),
  },
  'components/Venn/index.en': {
    frontmatter: fm74,
    toc: t74,
    demoIndex: dmi74,
    textGetter: () => import(/* webpackChunkName: "meta__Venn__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Venn/index.en.md?type=text'),
  },
  'components/Venn/index': {
    frontmatter: fm75,
    toc: t75,
    demoIndex: dmi75,
    textGetter: () => import(/* webpackChunkName: "meta__Venn__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Venn/index.md?type=text'),
  },
  'components/Violin/index.en': {
    frontmatter: fm76,
    toc: t76,
    demoIndex: dmi76,
    textGetter: () => import(/* webpackChunkName: "meta__Violin__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Violin/index.en.md?type=text'),
  },
  'components/Violin/index': {
    frontmatter: fm77,
    toc: t77,
    demoIndex: dmi77,
    textGetter: () => import(/* webpackChunkName: "meta__Violin" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Violin/index.md?type=text'),
  },
  'components/Waterfall/index.en': {
    frontmatter: fm78,
    toc: t78,
    demoIndex: dmi78,
    textGetter: () => import(/* webpackChunkName: "meta__Waterfall__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Waterfall/index.en.md?type=text'),
  },
  'components/Waterfall/index': {
    frontmatter: fm79,
    toc: t79,
    demoIndex: dmi79,
    textGetter: () => import(/* webpackChunkName: "meta__Waterfall" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Waterfall/index.md?type=text'),
  },
  'components/WordCloud/index.en': {
    frontmatter: fm80,
    toc: t80,
    demoIndex: dmi80,
    textGetter: () => import(/* webpackChunkName: "meta__WordCloud__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/WordCloud/index.en.md?type=text'),
  },
  'components/WordCloud/index': {
    frontmatter: fm81,
    toc: t81,
    demoIndex: dmi81,
    textGetter: () => import(/* webpackChunkName: "meta__WordCloud" */'/home/runner/work/GPT-Vis/GPT-Vis/src/WordCloud/index.md?type=text'),
  },
}

export { tabs as tabsMeta } from './tabs';
